import { convertCreditsFromServerToClient } from "../../../datastructures/Credits";
import { CommonData } from "../../../datastructures/gamestate/gameData";
import { createMovieClip } from "../../../functions/Functions_General";
import { PopupMessageBox } from "../../../messageBox";
import { Button } from "../../buttonsLibrary";
import { BuyBonusCard } from "./buyInCard";

interface BuyBonusData {
  price: number;
  currency: string;
}

export class BuyBonusMain {
  private parent: PIXI.Container = new PIXI.Container();

  private openCloseBtnContainer: PIXI.Container = new PIXI.Container();
  private openCloseBtnBgAnim: PIXI.extras.AnimatedSprite;
  private openCloseBtn: Button;
  private openBtnTexture: PIXI.Texture = PIXI.Texture.fromFrame(
    "bgBtnBonusBuyLandscape.png"
  );

  private openBtnTexturePortrait: PIXI.Texture = PIXI.Texture.fromFrame(
    "bgBtnBonusBuyPortrait.png"
  );
  private closeBtnTexture: PIXI.Texture = PIXI.Texture.fromFrame(
    "closeBonusBuy.png"
  );
  private totalcardsVisible: number = 3; // customize totalCards visible here <--------------------------- plus a ghost card that serve as
  private cardList: Array<BuyBonusCard> = [];
  private activeGameData: CommonData;
  public cardSize: Array<number> = [500, 800]; // customize percard size here <---------------------------
  private offsetBetweenCards: number;
  private offsetBetweenCardsLandscape: number;
  private offsetBetweenCardsPortrait: number;
  private isPortrait: boolean = false;

  private cardsparent: PIXI.Container = new PIXI.Container();
  private activeIndex: number = 1; //by default index one will be the center one
  private BuyBonusDataContainer: Array<BuyBonusData> = []; // = [1, 2, 3, 4, 5]//, 60000, 70000, 80000, 90000, 100000];
  private BtnPositionPortrait: number[] = [1920/2, 1080 + 250];
  private BtnPositionLandscape: number[] = [125, 1080/2+100];
  private nextPrevParent: PIXI.Container = new PIXI.Container();
  private nextBtn: Button = new Button(
    new PIXI.Sprite(PIXI.Texture.fromFrame("btn_Play.png"))
  );
  private previousBtn: Button = new Button(
    new PIXI.Sprite(PIXI.Texture.fromFrame("btn_Play.png"))
  );

  private buyBonusConfirmation: PopupMessageBox;
  private isOpen: boolean = false;
  private desaturateMatrix: PIXI.filters.ColorMatrixFilter;
  private displayPriceOpenCloseBtn: PIXI.Text;
  // private displayPriceOpenCloseBtnBg: PIXI.Sprite;
  private stakeChangeMenu: BonusBuyGameBetChangeBar;
  private enableBetChangeBtn:boolean=false;///--hide or show the  bet 
  private bonusIsEnabled:boolean=false;
  public constructor(
    parent: PIXI.Container,
    activeGameData: CommonData,
    totalBonus: number
  ) {
    
    //check if bonus is enabled
    if(activeGameData.loginResponse.gameSettings!=undefined && activeGameData.loginResponse.gameSettings.buyBonusEnabled!=undefined)
    {
      this.bonusIsEnabled=activeGameData.loginResponse.gameSettings.buyBonusEnabled;
    }


    this.totalcardsVisible = totalBonus;
    this.BuyBonusDataContainer = [
      { price: 100, currency: activeGameData.currency },
    ];
    this.BuyBonusDataContainer;
    this.activeGameData = activeGameData;
    //only add buy bonus interface if the bonus is enabled from server
    if(this.bonusIsEnabled)
    {
      parent.addChild(this.parent);
    }

    this.parent.addChild(this.cardsparent);

    let scaleFornotInFocus = 1; //
    this.offsetBetweenCardsLandscape =
      this.cardSize[0] * scaleFornotInFocus * 1.1;
    this.offsetBetweenCards = this.offsetBetweenCardsLandscape; //default  lanscape
    this.offsetBetweenCardsPortrait = this.offsetBetweenCards * 2;
    //create cards
    for (let i = 0; i < this.totalcardsVisible + 2; i++) {
      this.cardList[i] = new BuyBonusCard(
        this.cardsparent,
        [this.cardSize[0] * scaleFornotInFocus, this.cardSize[1]],
        activeGameData,
        i,
        this.totalcardsVisible + 2,
        this.offsetBetweenCards
      );

      let newx =
        this.activeGameData.size[0] / 2 -
        (this.offsetBetweenCards / 2) * (this.totalcardsVisible - 1) +
        this.offsetBetweenCards * i;

      if (i == this.totalcardsVisible + 1) {
        // last one move to very left
        newx =
          this.activeGameData.size[0] / 2 -
          (this.offsetBetweenCards / 2) * (this.totalcardsVisible - 1) -
          this.offsetBetweenCards * 1;
      }

      let newy = this.activeGameData.size[1] / 2;
      this.cardList[i].setPosition(newx, newy);
      //--update the cards

      //--set the last two card to be invisible;
      if (i >= this.totalcardsVisible) {
        this.cardList[i].setVisibleAfterAnimation(false);
      }
      if(activeGameData.loginResponse.gameSettings.buyBonusFactor!=undefined)
      {
        this.cardList[i].updatePrice(i * activeGameData.loginResponse.gameSettings.buyBonusFactor);
      }
     
    }
    //-
    

    if(this.enableBetChangeBtn)
    {
      this.stakeChangeMenu = new BonusBuyGameBetChangeBar(
        this.parent,
        this.activeGameData
      );
    }
  
    
  
    //--
    this.desaturateMatrix = new PIXI.filters.ColorMatrixFilter();
    this.desaturateMatrix.desaturate();
    this.createConfirmationmessage();
    this.setOffsetBewteenCards();
    //---
    this.cardsparent.alpha = 0;
    this.createBtns();
    this.setIndexOnFocus(3);
    // this.onToggleBonusBuyBntClick(); ///<-----------set visible by default for test

    // this.setPotraitMode(true);

    //-
    this.enableBuyBonusIfAllowed(false);
  }

  public onMoveComplete = (): void => {
    this.nextAndPreviousVisible(true);
    this.setIndexOnFocus(this.activeIndex);
  };
  private setIndexOnFocus = (index: number): void => {
    // console.log("------",index)
    //for safety
    if (index >= this.BuyBonusDataContainer.length) {
      index = this.BuyBonusDataContainer.length - 1;
      // console.log("maxreached")
    } else if (index <= 0) {
      index = 0;
      // console.log("minreached")
    }

    //--- assin as active index
    if (this.activeIndex != index) {
      this.activeIndex = index;
    }
    //--
    let indexInFocus = 0;
    if (this.totalcardsVisible > 0) {
      indexInFocus = Math.floor(this.totalcardsVisible / 2);
    }
    let dataToVieewIdnex = this.activeIndex;
    // console.log("infocus INDEX",indexInFocus)

    // update right//
    for (let i = indexInFocus; i < this.cardList.length - 1; i++) {
      this.cardList[indexInFocus].updatePrice(
        this.BuyBonusDataContainer[dataToVieewIdnex].price
      );

      // console.log(indexInFocus, this.BuyBonusDataContainer[dataToVieewIdnex].price)
      indexInFocus++;
      dataToVieewIdnex++;

      if (indexInFocus >= this.cardList.length) {
        indexInFocus = 0;
      }
      if (dataToVieewIdnex >= this.BuyBonusDataContainer.length) {
        dataToVieewIdnex = 0;
      }
    }

    //update left;
    indexInFocus = 0;
    if (this.totalcardsVisible > 0) {
      indexInFocus = Math.floor(this.totalcardsVisible / 2);
    }
    indexInFocus--;
    dataToVieewIdnex = this.activeIndex - 1;
    if (dataToVieewIdnex < 0) {
      dataToVieewIdnex = this.BuyBonusDataContainer.length - 1;
    }

    // for (let i = indexInFocus; i <0; i--) {

    // console.log(dataToVieewIdnex,"data index",indexInFocus, 'indexCCard inFocus',(j < indexInFocus+1) )
    let indexZeroinvisible = 0;
    //------------------
    // for (let j = indexInFocus; j<-1; j--) {
    // console.log("---->.....",indexInFocus)
    for (let j = 0; j < indexInFocus + 1; j++) {
      if (indexInFocus < Math.floor(this.totalcardsVisible / 2)) {
        this.cardList[indexInFocus].updatePrice(
          this.BuyBonusDataContainer[dataToVieewIdnex].price
        );
      }

      // console.log(indexInFocus, this.BuyBonusDataContainer[dataToVieewIdnex].price);

      indexInFocus--;
      dataToVieewIdnex--;

      if (indexInFocus < 0) {
        // break;
        indexInFocus = this.cardList.length - 1;
      }
      if (dataToVieewIdnex < 0) {
        dataToVieewIdnex = this.BuyBonusDataContainer.length - 1;
      }

      if (j == 0) {
        indexZeroinvisible = dataToVieewIdnex;
      }
    }
    //--update the last

    this.cardList[this.cardList.length - 1].updatePrice(
      this.BuyBonusDataContainer[indexZeroinvisible].price
    );
    // console.log("----*****",this.cardList.length-1, this.BuyBonusDataContainer[indexZeroinvisible].price);
  };
  private moveLeft = (): void => {
    // this.moveAllLeft(true);
    this.onMoveComplete();
    this.nextAndPreviousVisible(false);
    ///function that copy update tweens and move everything to left / right
    this.activeIndex++;
    if (this.activeIndex >= this.BuyBonusDataContainer.length) {
      this.activeIndex = 0;
    }

    for (let i = 0; i < this.cardList.length; i++) {
      this.cardList[i].moveLeft();
    }
  };
  private moveRight = (): void => {
    this.onMoveComplete();
    this.nextAndPreviousVisible(false);
    this.activeIndex--;
    if (this.activeIndex < 0) {
      this.activeIndex = this.BuyBonusDataContainer.length - 1;
    }
    for (let i = 0; i < this.cardList.length; i++) {
      this.cardList[i].moveRight();
    }

    // this.moveAllLeft(false);
  };

  private createBtns = (): void => {
    this.parent.addChild(this.openCloseBtnContainer);
    //--create the ingame visible price

    // this.displayPriceOpenCloseBtnBg = new PIXI.Sprite(
    //   PIXI.Texture.fromFrame("framePrize.png")
    // );
    // this.displayPriceOpenCloseBtnBg.anchor.set(0.5);
    const styleDecimal = new PIXI.TextStyle({
      dropShadow: true,
      dropShadowAngle: 40,
      fill: ["#f7cb60", "#fce174"],
      fillGradientStops: [0, 1],
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 25,
      lineHeight: 30,
      fontWeight: "bold",
      lineJoin: "round",
      
      align: "center",
    });
    this.displayPriceOpenCloseBtn = new PIXI.Text("2000", styleDecimal);

    this.displayPriceOpenCloseBtn.anchor.set(0.5);

    //-create bg for btn
    this.openCloseBtnBgAnim = createMovieClip("highLightBuyAnim", 0, 120);
    this.openCloseBtnBgAnim.anchor.set(0.5);
  
    this.openCloseBtnBgAnim.animationSpeed = 0.35;
    // this.openCloseBtnBgAnim.blendMode=PIXI.BLEND_MODES.ADD;

    this.openCloseBtnBgAnim.loop = true;
    this.openCloseBtnBgAnim.gotoAndPlay(0);

    //--create btns
    this.openCloseBtn = new Button(new PIXI.Sprite(this.openBtnTexture));
    // this.openCloseBtn.setPosition([70, 180]); /////////---------------------------------------close btn  position

    this.openCloseBtnContainer.addChild(this.openCloseBtn.getImage());
    this.openCloseBtn.getImage().addChild(this.openCloseBtnBgAnim);
    // this.openCloseBtn.getImage().addChild(this.displayPriceOpenCloseBtnBg);
    this.openCloseBtn.getImage().addChild(this.displayPriceOpenCloseBtn);
    this.openCloseBtn.setFunction(this.onToggleBonusBuyBntClick);
    this.openCloseBtn.setInteractive(true);
    this.displayPriceOpenCloseBtn.y=70;
    // this.displayPriceOpenCloseBtnBg.y = this.openCloseBtn.getHeight() * 0.6;

    //-nav btn

    this.previousBtn.setInteractive(true);
    this.previousBtn.getImage().scale.set(-1, 1);

    this.parent.addChild(this.nextPrevParent);
    this.nextPrevParent.addChild(this.nextBtn.getImage());
    this.nextPrevParent.addChild(this.previousBtn.getImage());

    this.nextBtn.setInteractive(true);

    // this.nextBtn.setPosition([
    //   this.activeGameData.size[0] - 70,
    //   this.activeGameData.size[1] / 2
    // ]); /////////---------------------------------------close btn  position

    // this.previousBtn.setPosition([70, this.activeGameData.size[1] / 2]); /////////---------------------------------------close btn  position

    this.previousBtn.setFunction(this.moveRight);
    this.nextBtn.setFunction(this.moveLeft);
  };

  public clear = (): void => {
    this.setVisible(false);
  };
  public loadDefault=():void=>
  {
    // console.log(this.activeGameData.betSelected)
    this.updatedisplayPriceOpenCloseBtn( this.activeGameData.betSelected.getServerVal());
    let isAllowedToBuyBonus= this.activeGameData.loginResponse.gameSettings.defaultAllowedInputActions.indexOf(this.activeGameData.API_handler.getServerActionBUY_BONUS())>=0;
    if(this.activeGameData.betResponse.gameContext.contextData.allowedInputActions!=undefined )
    {
      this.activeGameData.betResponse.gameContext.contextData.allowedInputActions=this.activeGameData.loginResponse.gameSettings.defaultAllowedInputActions;
    }
    this.enableBuyBonusIfAllowed(isAllowedToBuyBonus);
  }
  private onToggleBonusBuyBntClick = (): void => {
    if (this.isOpen ) {
      this.setVisible(false);
    } else {
      this.setVisible(true);
    }
    this.openConfirmation(false);
  };
  public getIsOpen = (): boolean => {
    return this.isOpen;
  };


 

  public checkBtnOrientationAndChange=():void=>
  {
      if( this.cardsparent.alpha == 0)
      {
        if(this.isPortrait)
        {
          this.openCloseBtn.getImage().texture = this.openBtnTexturePortrait;
          //align elements
          this.displayPriceOpenCloseBtn.scale.set(1.5);//-price in euro
          this.displayPriceOpenCloseBtn.y=30;
          this.displayPriceOpenCloseBtn.x=70;
          this.openCloseBtnBgAnim.y=-10;
          this.openCloseBtnBgAnim.x=-90;
          this.openCloseBtnBgAnim.scale.set(1.23);
        }
        else
        {
          this.openCloseBtn.getImage().texture = this.openBtnTexture;
          //--align elemnets
          this.displayPriceOpenCloseBtn.scale.set(1);//-price in euro
          this.displayPriceOpenCloseBtn.y=70;
          this.displayPriceOpenCloseBtn.x=0;
          this.openCloseBtnBgAnim.y=-40;
          this.openCloseBtnBgAnim.x=2;
          this.openCloseBtnBgAnim.scale.set(1);

        }
      }
     
    
  }
  public closeLocationUpdate=():void=>
  {
    if( this.cardsparent.alpha == 1)
    { if(this.isPortrait)
      {
        this.openCloseBtnContainer.position.set(
          150,
         150
        );
      }
      else
      {
        this.openCloseBtnContainer.position.set(
          75,
         400
        );
      }

    }
  }
  public setHidden=(bool: boolean): void => {
    ///-aloows to temperorly hide the btn
    this.parent.alpha=bool?0:1;
    this.parent.scale.set(bool?0:1);//--changing scale to not to mess up with interactivity
  }
  private setVisible = (bool: boolean): void => {

    if (bool) {
      this.cardsparent.alpha = 1;
      this.openCloseBtn.getImage().texture = this.closeBtnTexture;
      this.openCloseBtnBgAnim.alpha = 0;
       this.displayPriceOpenCloseBtn.alpha = 0;//-price in euro
      this.isOpen = true;
      // this.clear();
      this.activeGameData.blackScreen_buyIn.setAlpha(0.9);
      this.activeGameData.blackScreen_buyIn.setVisible(true);
      this.closeLocationUpdate();
      ///--check with balance
    } else {
      this.cardsparent.alpha = 0;
      // this.openCloseBtn.getImage().texture = this.openBtnTexture;
      this.checkBtnOrientationAndChange()
      this.openCloseBtnBgAnim.alpha = 1; //set visible hte btn again
      this.displayPriceOpenCloseBtn.alpha = 1;//-price in euro
      this.activeGameData.blackScreen_buyIn.setVisible(false);
      this.isOpen = false;
    }
    this.nextAndPreviousVisible(bool);
    if(this.enableBetChangeBtn)
    {
      this.stakeChangeMenu.setVisible(bool);
    }
  

    //disable btns
    this.enableDisableBuyBtnInCards(bool);
    this.hideCards(!bool);
    //--close
    this.setPotraitMode(this.isPortrait);
  };


  private enableDisableBuyBtnInCards=(bool: boolean):void=>
  {
    for (let i = 0; i < this.cardList.length; i++) {
      this.cardList[i].setBuyClickable(bool);
    }
  }

  private setOffsetBewteenCards = (): void => {
    if (this.isPortrait) {
      // console.log("--", this.isPortrait);
      this.cardsparent.scale.set(2);
      this.offsetBetweenCards = this.offsetBetweenCardsPortrait;

      if (this.totalcardsVisible % 2 == 0) {
        //if pair
        this.cardsparent.x =
          -this.activeGameData.size[0] / 2 - this.offsetBetweenCards;
      } else {
        //if impair
        this.cardsparent.x = -this.activeGameData.size[0] / 2;
      }
    } else {
      this.cardsparent.scale.set(1);
      this.offsetBetweenCards = this.offsetBetweenCardsLandscape;
      this.cardsparent.x = 0;
    }

    //---update card positions
    for (let i = 0; i < this.totalcardsVisible + 2; i++) {
      let newx =
        this.activeGameData.size[0] / 2 -
        (this.offsetBetweenCards / 2) * (this.totalcardsVisible - 1) +
        this.offsetBetweenCards * i;

      if (i == this.totalcardsVisible + 1) {
        // last one move to very left
        newx =
          this.activeGameData.size[0] / 2 -
          (this.offsetBetweenCards / 2) * (this.totalcardsVisible - 1) -
          this.offsetBetweenCards * 1;
      }

      let newy = this.activeGameData.size[1] / 2 - 45;
      this.cardList[i].setPosition(newx, newy);
    }
  };

  public setPotraitMode = (bool: boolean): void => {
    this.isPortrait = bool;
 
    this.setOffsetBewteenCards();

    //if portrait mode  set visible oly one btn and  others are invisible
    if (bool) {
      // console.log("PORTrAIT====");
      for (let i = 0; i < this.cardList.length; i++) {
        this.cardList[i].setPortraitMode(true);
      }
     
      ///scale the interface
      this.nextBtn.getImage().scale.set(2);
      this.previousBtn.getImage().scale.set(-2, 2);
      this.openCloseBtn.getImage().scale.set(1.5);
      this.previousBtn.setPosition([70, this.activeGameData.size[1] / 2]);

      this.previousBtn.setPosition([120, this.activeGameData.size[1]]);
      this.nextBtn.setPosition([
        this.activeGameData.size[0] - 120,
        this.activeGameData.size[1],
      ]);
      // this.openCloseBtn.setPosition(this.BtnPositionPortrait); /////////---------------------------------------close btn  position

      this.openCloseBtnContainer.position.set(
        this.BtnPositionPortrait[0],
        this.BtnPositionPortrait[1]
      );
      //if  we have more cards data than 1 on portrait display nav

      let containsMoreThanOneData = this.BuyBonusDataContainer.length > 1;
      this.setNextPreviousPArentVisible(containsMoreThanOneData);

      //----

      this.cardsparent.scale.set(2);
      this.offsetBetweenCards = this.offsetBetweenCardsPortrait;

      if (this.totalcardsVisible % 2 == 0) {
        //if pair
        this.cardsparent.x =
          -this.activeGameData.size[0] / 2 - this.offsetBetweenCards;
      } else {
        //if impair
        this.cardsparent.x = -this.activeGameData.size[0] / 2;
      }



    } else {
      // console.log("LANDSCAPE====");

      for (let i = 0; i < this.cardList.length; i++) {
        this.cardList[i].setPortraitMode(false);
      }
      ///scale the interface
      this.nextBtn.getImage().scale.set(1);
      this.previousBtn.getImage().scale.set(-1, 1);
      this.openCloseBtn.getImage().scale.set(1);
      this.previousBtn.setPosition([70, this.activeGameData.size[1] / 2]);
      this.nextBtn.setPosition([
        this.activeGameData.size[0] - 70,
        this.activeGameData.size[1] / 2,
      ]);
      // this.openCloseBtn.setPosition(this.BtnPositionLandscape); /////////---------------------------------------close btn  position
      this.openCloseBtnContainer.position.set(
        this.BtnPositionLandscape[0],
        this.BtnPositionLandscape[1]
      );
      //-if we have more cards than visible cards
      let containsMoreThanOneData =
        this.BuyBonusDataContainer.length > this.totalcardsVisible;
      this.setNextPreviousPArentVisible(containsMoreThanOneData);
      
    }
    if(this.enableBetChangeBtn)
    {
      this.stakeChangeMenu.setIsPortrait(bool);
    }

    //adjustments
    this.checkBtnOrientationAndChange();
    this.closeLocationUpdate();

  };

  private setNextPreviousPArentVisible = (bool: boolean): void => {
    this.nextPrevParent.scale.set(bool ? 1 : 0);
  };

  private nextAndPreviousVisible = (bool: boolean): void => {
    //-used this function when ever interacting with the btn
    this.nextBtn.setInteractive(bool);
    this.nextBtn.getImage().alpha = bool ? 1 : 0;
    this.previousBtn.setInteractive(bool);
    this.previousBtn.getImage().alpha = bool ? 1 : 0;
  };
  //----------------CUTOMIZE
  public setPortraitPositionBuyBtn = (newPos: number[]): void => {
    this.BtnPositionPortrait = newPos;
    this.setPotraitMode(this.isPortrait);
  };
  public setlandScapePositionBuyBtn = (newPos: number[]): void => {
    this.BtnPositionLandscape = newPos;
    this.setPotraitMode(this.isPortrait);
  };

  public setCardImageAllCards = (cardnameWithExtension: string): void => {
    for (let i = 0; i < this.cardList.length; i++) {
      this.cardList[i].setNewTextureCard(cardnameWithExtension);
    }
  };

  ///-

  private createConfirmationmessage = (): void => {
    this.buyBonusConfirmation = new PopupMessageBox(
      2,
      this.activeGameData.size,
      this.activeGameData
    );
    this.buyBonusConfirmation.setAllowBlackScreen(false);
    this.buyBonusConfirmation.getFrame().tint = 0x00000;
    this.buyBonusConfirmation.setHeadText("");
    this.buyBonusConfirmation.setBodyText(" CONFIRMATION TEXT?");
    this.buyBonusConfirmation.setLabel(
      0,
      this.activeGameData.gameTextGeneral.NO
    );
    this.buyBonusConfirmation.setLabel(
      1,
      this.activeGameData.gameTextGeneral.YES
    );

    this.buyBonusConfirmation.setButtons(0, this.onCancelBuy);
    this.buyBonusConfirmation.setButtons(1, this.onConfirmBuy);


    ///// CUSTOMIZE BACKGROUND FOR POPSCREEN
    // let newbg = new PIXI.Sprite(
    //   PIXI.Texture.fromFrame("buyInPopupMessageBox.png")
    // );
    // newbg.anchor.set(0.5);
    // // newbg.scale.set(1.2);
    // newbg.y = this.buyBonusConfirmation.getFrame().height / 2 - 30; //this.messageBoxNewDesign.height;
    // newbg.x = this.buyBonusConfirmation.getFrame().width / 2; //this.messageBoxNewDesign.width/2;

    // this.buyBonusConfirmation.getFramenull().addChild(newbg);
    // this.buyBonusConfirmation.setAlphaDefaultFrame(0);
  };
  public onConfirmBuy = (): void => {
    // this.isOpen=false;
    this.activeGameData.BuyBonus.clear();
    this.activeGameData.serverAction = this.activeGameData.API_handler.getServerActionBUY_BONUS(); //--just change the action type upon buy confirmation
    //   this.activeGameData.onBetBuySuccessFunction(this.activeGameData);////-----------------------this has to be defined for each game < its basically START PLAy FUNCTION
    this.activeGameData.playFunction(this.activeGameData); ////-----------------------this has to be defined for each game < its basically START PLAy FUNCTION
  };
  private onCancelBuy = (): void => {
    // this.activeGameData.BuyBonus.clear();

    this.openConfirmation(false);
    this.hideCards(false);
  };
  public hideCards = (bool: boolean): void => {
    this.cardsparent.scale.set(bool ? 0 : 1);
  };
  private updateConfirmationMessage = (): void => {
    let serVerPRICEValue: number = 1000;

    let amount: string = convertCreditsFromServerToClient(
      serVerPRICEValue
    ).toFixed(2);
    let currency: string = this.activeGameData.currency;
    this.buyBonusConfirmation.setBodyText(
      this.activeGameData.gameTextGeneral.BONUSBUYCONFIRMATION +
        " " +
        amount +
        currency +
        "?"
    );
  };
  public openConfirmation = (bool: boolean): void => {
    if (bool) {
      this.updateConfirmationMessage();
    }
    this.buyBonusConfirmation.setMessageBoxVisibile(bool);

    if (bool) {
      this.hideCards(true);
    }
    //--hide the cards
    // this.setVisible(false);
    // this.activeGameData.BuyBonus.clear();
  };

  public enableBuyBonusIfAllowed = (bool: boolean): void => {
    if (this.activeGameData.replayMode) {
      bool = false;
    }
    else if(this.activeGameData.BuyBonusIsClientSideReady==false)
    {
      //if the  clientside isnt ready to display the animation dont display it 
      bool = false;
    }
    if(bool)
    { 
      //check if balance allows it
     bool= this.checkIfBonusBuyable();
    }

    this.openCloseBtn.setInteractive(bool);
    this.openCloseBtn.getImage().filters = bool
      ? null
      : [this.desaturateMatrix];
    if (bool) {
      this.openCloseBtnBgAnim.gotoAndPlay(0);
    } else {
      this.openCloseBtnBgAnim.gotoAndStop(0);
    }
  };
  public updatedisplayPriceOpenCloseBtn = (serverValue: number): void => {
    // console.log('---',serverValue)
    let clientval = convertCreditsFromServerToClient(serverValue);    
      if(this.enableBetChangeBtn)
      {
        this.stakeChangeMenu.updateBetAmount();
      }
      //update price for card
      if(this.activeGameData.loginResponse.gameSettings.buyBonusFactor!=undefined)
      {
        this.displayPriceOpenCloseBtn.text =
        " " + clientval * this.activeGameData.loginResponse.gameSettings.buyBonusFactor + "" + this.activeGameData.currency;

      for (let i = 0; i < this.cardList.length; i++) {
        this.cardList[i].updatePrice(serverValue*this.activeGameData.loginResponse.gameSettings.buyBonusFactor)        
      }
    }
    else
    {
      console.log("buyBonusFactor Missing from gameSettings")
    }
      this.enableDisableBuyBtnInCards(this.isOpen);
      // console.log(this.activeGameData.betIndex)
      // this.checkIfBonusBuyable()
      this.enableBuyBonusIfAllowed(true);
  };
  private checkIfBonusBuyable=():boolean=>
  {
   
    // let betResponseBal=this.activeGameData?.betResponse?.playerBalance?.creditsBalance?.amount;    
    // let playerBalInCents=typeof(betResponseBal)==='number'?betResponseBal:this.activeGameData.balance.getServerVal();
    let bonusBuyPriceForCurrentStale=this.activeGameData.betSelected.getServerVal()*this.activeGameData.loginResponse.gameSettings.buyBonusFactor;
    

    let playerBalInCents:number=0;
    let isAllowed= false
    if(this.activeGameData?.betResponse?.gameContext!=undefined)
    {
      // console.log('betResponse',this.activeGameData?.betResponse);
      // console.log('allowedAction',this.activeGameData?.betResponse?.gameContext?.contextData?.allowedInputActions);
      // console.log('balance',this.activeGameData?.betResponse?.playerBalance?.creditsBalance?.amount);
      isAllowed=this.activeGameData?.betResponse?.gameContext?.contextData?.allowedInputActions?.indexOf(this.activeGameData.API_handler.getServerActionBUY_BONUS())>=0;
      playerBalInCents=this.activeGameData?.balance.getServerVal();
    }
    else
    {
      // console.log('player update from login response',this.activeGameData?.betResponse);
      isAllowed=this.activeGameData?.loginResponse?.gameContext?.contextData?.allowedInputActions?.indexOf(this.activeGameData.API_handler.getServerActionBUY_BONUS())>=0;
      playerBalInCents=this.activeGameData?.loginResponse.playerBalance.creditsBalance.amount;
    }

    let canPurchase=bonusBuyPriceForCurrentStale<=playerBalInCents;
    let isAllowedToBuy=canPurchase &&isAllowed;

    // console.log('canRebuy:', isAllowedToBuy,'(enough balance:',canPurchase,'  isallowed',isAllowed,')');
    
    return isAllowedToBuy;
  
  }
}

class BonusBuyGameBetChangeBar {
  private parent: PIXI.Container = new PIXI.Container();
  private interfaceContainer: PIXI.Container = new PIXI.Container();
  private betText: PIXI.Text;
  private betIncrease: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("buyBonusNext.png")
  );
  private betDecrease: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("buyBonusNext.png")
  );
  private activeGameData: CommonData;
  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    
    parent.addChild(this.parent);
    this.parent.addChild(this.interfaceContainer);
    this.activeGameData = activeGameData;

    const styleDecimal =new PIXI.TextStyle({
      dropShadow: false,
      dropShadowAngle: 0,
      fill: ["#fff5c2", "#ffa629"],
      fillGradientStops: [0, 1],
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });

    this.betText = new PIXI.Text(this.activeGameData.betSelected.getDisplayValue(), styleDecimal);
    this.betText.anchor.set(0.5);
    this.interfaceContainer.addChild(this.betText);

    //-
    this.betDecrease.scale.set(-1, 1);
    this.betDecrease.anchor.set(0.5);
    this.betIncrease.anchor.set(0.5);
    this.betDecrease.x = -250;
    this.betIncrease.x = this.betDecrease.x * -1;
    this.betDecrease.on('pointertap',this.onDecreaseClick);
    this.betIncrease.on('pointertap',this.onIncreaseClick);

    this.interfaceContainer.addChild(this.betDecrease);
    this.interfaceContainer.addChild(this.betIncrease);
    //-
    this.updateBetAmount();
  }
  private setPosition = (posx: number, posy: number): void => {
    this.parent.x = posx;
    this.parent.y = posy;
  };
  // publi
  public setIsPortrait = (bool: boolean): void => {
    if (bool) {
      this.parent.scale.set(2);
      this.setPosition(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[0] + 100
      );
    } else {
      this.parent.scale.set(1);
      this.setPosition(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[1] - 50
      );
    }
  };
  private onDecreaseClick=():void=>
  { 
  
    // console.log("request decrease");
    this.activeGameData.betChangeFunction(
      "down",
      this.activeGameData
    )
  }
  private onIncreaseClick=():void=>
  {
    // console.log("request increase");
    this.activeGameData.betChangeFunction(
      "up",
      this.activeGameData
    )
  }
  public getparent=():PIXI.Container=>
  {
    return this.parent;
  }
  public setVisible = (bool: boolean): void => {
    this.parent.alpha = bool ? 1 : 0;
    this.betDecrease.interactive = bool;
    this.betDecrease.buttonMode = bool;

    this.betIncrease.interactive = bool;
    this.betIncrease.buttonMode = bool;
  };
  public updateBetAmount=():void=>
  {
   this.betText.text=this.activeGameData.gameTextGeneral.bet+": "+ this.activeGameData.betSelected.getDisplayValue()+this.activeGameData.currency;
    
  }

  
}
